import React from "react";
import { Modal, Button, Icon } from "antd";

const typeConfig = {
  error: {
    icon: "close-circle",
    color: "#ff4d4f",
    bgColor: "#fff1f0",
    borderColor: "#ffa39e",
  },
  warning: {
    icon: "exclamation-circle",
    color: "#faad14",
    bgColor: "#fffbe6",
    borderColor: "#ffe58f",
  },
  info: {
    icon: "info-circle",
    color: "#1890ff",
    bgColor: "#e6f7ff",
    borderColor: "#91d5ff",
  },
  success: {
    icon: "check-circle",
    color: "#52c41a",
    bgColor: "#f6ffed",
    borderColor: "#b7eb8f",
  },
};

const AlertModal = ({
  visible,
  onClose,
  message = "",
  type = "info",
  title = "Notice",
}) => {
  const config = typeConfig[type] || typeConfig.info;

  return (
    <Modal
      visible={visible}
      footer={null}
      centered
      closable={false}
      title={
        <div style={{ display: "flex", alignItems: "center" }}>
          <Icon
            type={config.icon}
            style={{ fontSize: 20, color: config.color, marginRight: 8 }}
          />
          <span style={{ fontWeight: 500, fontSize: 18, color: "#000" }}>
            {title}
          </span>
        </div>
      }
    >
      <div
        style={{
          backgroundColor: config.bgColor,
          border: `1px solid ${config.borderColor}`,
          borderRadius: 8,
          padding: "16px 20px",
          marginBottom: 16,
          marginTop: -10,
          fontSize: 14,
          color: "#333",
          lineHeight: 1.8,
          whiteSpace: "pre-line",
          boxShadow: "inset 0 1px 3px rgba(0,0,0,0.05)",
        }}
      >
        {message}
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button type="primary" onClick={onClose} style={{ borderRadius: 6 }}>
          Okay, Got it
        </Button>
      </div>
    </Modal>
  );
};

export default AlertModal;
